import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../app/app.service';
import { AuthService } from '@auth0/auth0-angular';

declare var $: any;


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public phoneNumber: String;
  public password: String;
  public userInfo: any;
  public isError:boolean;
  public errorMessage:String;
  public code;

  constructor(private router: Router, private appService:AppService, public auth: AuthService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.code = this.route.snapshot.queryParamMap.get('code');
    if (this.code) {
      localStorage.setItem('auth', '1');
      this.router.navigateByUrl('/products');
    }
  }

  phoneInput(e) {
    let x = e.which || e.keycode;
    if ((x >= 48 && x <= 57) || x === 8 ||
      (x >= 35 && x <= 40) || x === 46 || (x >= 96 && x <= 105 ) || x === 9)
      return true;
    else
      return false;
  }

  forgotPassword() {
    this.router.navigate(['/forgotPassword']);
  }

  signInFunction() {
     {
      const data = {
        phoneNumber: this.phoneNumber,
        password: this.password,
      };
      this.router.navigateByUrl('/products')
    }
  }

  signInClickUP(){
    // this.appService.clickUPAuthorization()
    this.auth.loginWithRedirect();
  }

}
